import { FieldVisitStatus } from "@/constants/entity-status";
import { AppColors } from "@/styles/colors";
import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import { RequestStatusBadge } from "../../badge/RequestStatusBadge";

interface Props {
  titular?: string;
  contacto?: string;
  destino?: string;
  fechaDeseada?: string;
  fechaFinal?: string;
  motivoVisita?: string;
  tecnicoAsignado?: string;
  estadoDescripcion?: string;
}

export const FieldVisitMainData = ({
  titular,
  contacto,
  destino,
  fechaDeseada,
  fechaFinal,
  motivoVisita,
  tecnicoAsignado,
  estadoDescripcion,
}: Props) => {
  return (
    <Grid templateColumns="repeat(2, 1fr)" gap={18}>
      <GridItem>
        <Flex
          flexDir="column"
          padding="12px"
          height="100%"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
          borderRadius="12px"
        >
          <Text
            className="amd-card-title"
            paddingBottom="10px"
            textTransform="uppercase"
            paddingX="24px"
            fontWeight={700}
          >
            Detalle
          </Text>

          <Grid templateColumns="repeat(2, 1fr)" gridAutoRows="50px">
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
              display="flex"
              alignItems="center"
            >
              <Text className="account-title-label">Titular cuenta:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
              display="flex"
              alignItems="center"
            >
              <Text className="account-value-label">{titular ?? "-"}</Text>
            </GridItem>

            <GridItem
              paddingX="24px"
              paddingY="8px"
              display="flex"
              alignItems="center"
            >
              <Text className="account-title-label">Contacto:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              display="flex"
              alignItems="center"
            >
              <Text className="account-value-label">{contacto ?? "-"}</Text>
            </GridItem>

            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
              display="flex"
              alignItems="center"
            >
              <Text className="account-title-label">Destino:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
              display="flex"
              alignItems="center"
            >
              <Text className="account-value-label">{destino ?? "-"}</Text>
            </GridItem>

            <GridItem
              paddingX="24px"
              paddingY="8px"
              display="flex"
              alignItems="center"
            >
              <Text className="account-title-label">Fecha deseada:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              display="flex"
              alignItems="center"
            >
              <Text className="account-value-label">
                {fechaDeseada ? dayjs(fechaDeseada).format("DD/MM/YYYY") : "-"}
              </Text>
            </GridItem>
          </Grid>
        </Flex>
      </GridItem>

      <GridItem>
        <Flex
          flexDir="column"
          padding="12px"
          height="100%"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
          borderRadius="12px"
        >
          <Text
            className="amd-card-title"
            paddingBottom="16px"
            textTransform="uppercase"
            paddingX="24px"
            fontWeight={700}
            visibility="hidden"
          >
            -
          </Text>

          <Grid templateColumns="repeat(2, 1fr)" gridAutoRows="50px">
            <GridItem
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
              paddingX="24px"
              paddingY="8px"
              display="flex"
              alignItems="center"
            >
              <Text className="account-title-label">Motivo:</Text>
            </GridItem>
            <GridItem
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
              paddingX="24px"
              paddingY="8px"
              display="flex"
              alignItems="center"
            >
              <Text className="account-value-label">{motivoVisita ?? "-"}</Text>
            </GridItem>

            <GridItem
              paddingX="24px"
              paddingY="8px"
              display="flex"
              alignItems="center"
            >
              <Text className="account-title-label">Técnico asignado:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              display="flex"
              alignItems="center"
            >
              <Text className="account-value-label">
                {tecnicoAsignado ?? "-"}
              </Text>
            </GridItem>

            <GridItem
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
              paddingX="24px"
              paddingY="8px"
              display="flex"
              alignItems="center"
            >
              <Text className="account-title-label">Estado:</Text>
            </GridItem>
            <GridItem
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
              paddingX="24px"
              paddingY="8px"
              display="flex"
              alignItems="center"
            >
              <Text as="span" className="account-value-label">
                <RequestStatusBadge
                  status={estadoDescripcion as unknown as FieldVisitStatus}
                />
              </Text>
            </GridItem>

            <GridItem
              paddingX="24px"
              paddingY="8px"
              display="flex"
              alignItems="center"
            >
              <Text className="account-title-label">Fecha final:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              display="flex"
              alignItems="center"
            >
              <Text className="account-value-label">
                {fechaFinal ? dayjs(fechaFinal).format("DD/MM/YYYY") : "-"}
              </Text>
            </GridItem>
          </Grid>
        </Flex>
      </GridItem>
    </Grid>
  );
};

